export function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-300 py-8 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <p className="mb-2">© AK-KUR Furniture & Fitting Ltd</p>
        <p className="text-neutral-400">kurfurniture.co.uk</p>
      </div>
    </footer>
  );
}
